import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
import Vant from 'vant'
import 'vant/lib/index.css';
import i18n from './language/index.js' // 第一步：引入多语言配置文件index.js

import vuex from 'vuex'
Vue.use(ElementUI);
Vue.use(vuex)
Vue.use(Vant)

import store from './store';
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(Layout)
});
